module.exports = __webpack_public_path__ + "img/csbg.76b89648.png";